export default [

     {
          path: '/deliverable',
          name: 'Deliverable',
          component: () => import("@/views/Page/Deliverable/Deliverable.vue"),
           meta: {
               title: 'GRC | Deliverable',
          },
     }
];